<script>

import Logo from "@/components/Logo.vue";

export default {
    components: {Logo},
    data() {
        return {
            email: '',
            password: '',
            loading: false,
            error: null
        }
    },
    methods: {
        login() {
            this.loading = true;
            this.$auth.login({email: this.email, password: this.password}).then((data) => {
                this.loading = false;
                if (data && data.error) {
                    this.error = data.error;
                }
            });
        }
    }
}

</script>
<template>
    <section class="hero is-fullheight">
        <div class="hero-body">
            <div class="container">
                <a href="/"><Logo/></a>
                <div class="columns is-centered">
                    <div class="column is-6-tablet is-4-desktop is-4-widescreen">
                        <form @submit.prevent="login" class="panel is-link">
                            <p class="panel-heading">
                                {{ $t('auth.login.title_label') }}
                            </p>
                            <div class="box no-top-radius">

                                <b-field :label="$t('auth.fields.email.name')"
                                         label-for="email">
                                    <b-input required
                                             type="email"
                                             id="email"
                                             autofocus
                                             name="email"
                                             :placeholder="$t('auth.fields.email.placeholder')"
                                             v-model="email"
                                             icon="at"
                                    ></b-input>
                                </b-field>

                                <b-field :label="$t('auth.fields.password.name')"
                                         :type="error ? 'is-danger' : null"
                                         :message="error"
                                         label-for="password">
                                    <b-input
                                        id="password"
                                        required
                                        type="password"
                                        name="password"
                                        placeholder="********"
                                        v-model="password"
                                        icon="lock"
                                    ></b-input>
                                </b-field>

                                <div class="my-4">
                                    <RouterLink to="/logowanie-kodem">
                                        {{ $t('auth.actions.one_time_code_login') }}
                                    </RouterLink>
                                </div>

                                <div class="my-4">
                                    <RouterLink to="/odzyskiwanie-hasla">
                                        {{ $t('auth.actions.password_forgot') }}
                                    </RouterLink>
                                </div>
                                <div class="buttons is-centered">
                                    <button class="button is-success is-fullwidth" type="submit"
                                            v-bind:disabled="loading"
                                            v-bind:class="{'is-loading': loading}">
                                        {{ $t('auth.actions.login') }}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
